import {ButtonHTMLAttributes, ReactElement, ReactNode} from "react";
import {omit} from "ramda";

export interface SecondaryButtonProps {
    pressed?: boolean
    children: ReactNode
}

export function SecondaryButton(props: SecondaryButtonProps & ButtonHTMLAttributes<HTMLButtonElement>): ReactElement {
    const pressed = props.pressed ?? false;
    const restAttributes = omit(["children", "className", "pressed"], props);
    return (
        <button className={`rounded-full border border-gray-1
                            px-5 py-2
                            text-primary font-barlow font-semibold leading-none
                            ${pressed ? 'bg-warm-gray' : 'bg-white'} ${props.className}`}
                {...restAttributes}>
            {props.children}
        </button>
    );
}